module.exports = __webpack_public_path__ + "static/media/flags.9c74e172.png";